import { fields, createSchema, validate as _validate } from '..';

const {
  requiredText,
  optionalText,
  interestsAtLeastOne,
  requiredArrayOfStrings,
  optionalArrayOfString,
} = fields;

const schema = createSchema({
  confidentInMathsAbility: requiredText,
  canManageEverydayLife: requiredText,
  communicateWellWithOthers: requiredText,
  budgetManageMoney: requiredText,
  everydayTasksWithNumbers: requiredText,
  dealWithConflict: requiredText,
  mathsGoals: requiredText,
  optimisticAboutFuture: requiredText,
  education: requiredText,
  employment: requiredText,

  firstLanguage: optionalText,
  ethnicity: optionalText,
  genders: optionalArrayOfString,
  interests: interestsAtLeastOne,
  personalGoals: requiredArrayOfStrings,
  hasDeviceInternetAccess: optionalText,
  usesDeviceType: optionalArrayOfString,
  confidentUsingTechnology: optionalText,
});

const validate = (data) => _validate(schema, data);

export default validate;
